import { createSlice } from "@reduxjs/toolkit";
import { IEvent } from "../interface/IEvent";

const initialState: IEvent | null = null;

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    setEventStore: (state: IEvent | null, action: any | null) => {
      return action.payload;
    },
  },
});

export const { setEventStore } = eventSlice.actions;

export default eventSlice.reducer;
